// client/guest/components/EulaBlock.tsx
// client/guest/components/EulaBlock.tsx
import React from "react";

export default function EulaBlock({
  required,
  text,
  onAccept,
}: {
  required: boolean;
  text?: string | null;
  onAccept: () => void;
}) {
  if (!required)
    return <div className="text-[13px] text-white/70">Оферта уже принята.</div>;

  const eula = (text || "").trim();

  return (
    <div className="flex-1 min-h-0 flex flex-col gap-3">
      <div className="min-h-0 flex-1 overflow-y-auto rounded-2xl border border-white/10 bg-white/5 px-3.5 py-3 text-[13px] text-white/85 whitespace-pre-wrap break-words">
        {eula || "Для участия нужно принять оферту мероприятия."}
      </div>
      <div className="shrink-0">
        <button
          onClick={onAccept}
          className="w-full rounded-2xl bg-emerald-600/95 px-4 py-3 font-semibold text-white hover:bg-emerald-500 transition"
        >
          Принимаю
        </button>
      </div>
    </div>
  );
}